import { TitleCasePipe } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MenuItem, MessageService } from "primeng/api";
import { Subject, forkJoin, takeUntil } from "rxjs";
import { AppMainService } from "src/app/app-main.service";
import { PackBoxService } from "src/app/configurations/inventory/setup/pack-box/pack-box.service";
import { Severity } from "src/app/inventory/constants/constants";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { Status } from "../../models/status";
import { SOChannel, SoStageId } from "src/app/inventory/sales-order/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
@Component({
    selector: "app-easypost-shipment",
    templateUrl: "./easypost-shipment.component.html",
    styleUrls: ["./easypost-shipment.component.scss"],
})
export class EasypostShipmentComponent implements OnInit, OnChanges {
    @Input() displayAddPackage;
    @Input() detailsObj;
    @Input() channel;
    @Input() selectedCarrier;
    @Output() onLabelCreate = new EventEmitter();
    @Output() onClose = new EventEmitter();
    @Output() onStepChange = new EventEmitter();
    @ViewChild("stepper") stepper: ElementRef;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    menus: MenuItem[];
    activeIndex = 0;
    packageType = [];
    packageAmount = [
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" },
    ];
    massOptions = [
        { id: 1, name: "Pound", code: "POUND" },
        { id: 2, name: "Kilogram", code: "KILOGRAM" },
        { id: 3, name: "Ounce", code: "OUNCE" },
        { id: 4, name: "Stone", code: "STONE" },
    ];
    selectedOption: string[] = [];
    packageGroup = [{}];
    services = [
        {
            id: 1,
            name: "UPS Ground",
            deliverBy: "Monday 07/11/22 by end of Day",
            cost: "$87.25",
        },
        {
            id: 2,
            name: "UPS Express",
            deliverBy: "Friday 07/18/22 by end of Day",
            cost: "$127.25",
        },
    ];
    selectedService;
    shippingAddress;
    form:FormGroup = this.fb.group({
        packages: this.fb.array([]),
    });
    shipmentRates = [];
    shipment;
    isSinglePackage = false;
    order;
    allPackBoxes = [];
    defaultPackage;
    paymentMethod = [];
    defaultMethod;
    ratesText;
    createLabelSubmitted = false;
    shippingAddressContact;

    codAmount = 0;
    isVisibleShipCostField = false;
    shippingCost = 0;
    isVisibleCodField = false;
    isFreeShipping = false;
    soChannel = SOChannel;
    // fraction digits
    fractionDigits: number = 0;

    constructor(
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private packBoxService: PackBoxService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService,
        private utilityService: UtilityService,
        private importService: ImportserialService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detailsObj && changes.detailsObj.currentValue) {
            this.detailsObj = changes.detailsObj.currentValue;
            this.shippingAddress = this.detailsObj?.account?.accountAddresses?.filter((d) => d.addressId == this.detailsObj.shippingAddressId)[0];
            this.paymentMethod = [];
            if (this.detailsObj?.account?.accountPaymentMethods) {
                this.detailsObj?.account?.accountPaymentMethods.forEach((e) => {
                    this.paymentMethod.push(e.paymentMethod);
                    if (e.isDefault) {
                        this.defaultMethod = e.paymentMethod;
                    }
                });
            }
            this.shippingAddressContact = this.detailsObj?.shipContact;
        }
        if (changes.displayAddPackage && changes.displayAddPackage.currentValue) {
            this.displayAddPackage = changes.displayAddPackage.currentValue;
            if (this.displayAddPackage) {
                this.initForm();
                this.addPackage();
            }
        }
        this.activeIndex = 0;
        this.createLabelSubmitted = false;
        this.selectedService = null;
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.menus = [{}, {}, {}, {}];
        this.getAllPackBoxList();
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    getAllPackBoxList() {
        this.packageType = [];
        this.packBoxService.getPackBoxListWithHierarchy().subscribe(
            (res) => {
                this.allPackBoxes = res;
                const allPackages = [];
                let defaultChild;
                if (this.allPackBoxes && this.allPackBoxes.length) {
                    this.allPackBoxes.forEach((box) => {
                        if (box.statusId == Status.Active) {
                            const child = [];
                            if (box.childPackBoxes && box.childPackBoxes.length) {
                                box.childPackBoxes.forEach((ch) => {
                                    if (ch.statusId == Status.Active) {
                                        const childData = {
                                            label: ch.name,
                                            value: ch.id,
                                            data: ch,
                                        };
                                        child.push(childData);
                                        if (ch.isDefault) {
                                            defaultChild = childData;
                                        }
                                    }
                                });
                            }
                            const parentData = {
                                label: box.name,
                                value: box.id,
                                children: child,
                            };
                            allPackages.push(parentData);
                            if (box.isDefault && defaultChild && defaultChild.data.parentId == box.id) {
                                this.defaultPackage = defaultChild;
                            }
                        }
                    });
                }
                this.packageType = allPackages;
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }

    initForm() {
        this.form = this.fb.group({
            packages: this.fb.array([]),
        });
    }

    editPackage() {}

    backStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i >= step) {
                arr[i].classList.remove("activeItem");
            }
        }
        this.activeIndex = this.activeIndex - 1;
        if (step == 2) {
            this.selectedService = null;
        } else if (step == 3) {
            this.createLabelSubmitted = false;
        }
        if (this.activeIndex == 0) {
            this.onStepChange.emit(true);
        }
    }
    nextStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i < step + 1) {
                arr[i].classList.add("activeItem");
            }
        }
        if (step == 1) {
            this.getShippingCost();
        } else if (step == 2) {
            this.shippingCost = Number(this.selectedService?.rate);
            this.calculateCODAmount();
        }
        this.activeIndex = this.activeIndex + 1;
        if (this.activeIndex > 0) {
            this.onStepChange.emit(false);
        }
    }

    get packages() {
        return this.form.controls["packages"] as FormArray;
    }

    addPackage() {
        const packagreForm = this.fb.group({
            packageType: [this.defaultPackage],
            totalPackage: [{ id: 1, name: "1" }],
            mass: [this.massOptions[0]],
            weight: [this.defaultPackage ? this.defaultPackage.data.weight : "", Validators.required],
            length: [this.defaultPackage ? this.defaultPackage.data.length : "", Validators.required],
            width: [this.defaultPackage ? this.defaultPackage.data.width : "", Validators.required],
            height: [this.defaultPackage ? this.defaultPackage.data.height : "", Validators.required],
            packageValue: [""],
            reference1: [this.channel == "SALESORDER" && this.detailsObj.salesOrderStageId == SoStageId.Shipped ? this.detailsObj?.invoiceNo : this.detailsObj?.number, Validators.required],
            reference2: [""],
            codAmount: ["17.5"],
            codMethod: [this.defaultMethod ? this.defaultMethod : ""],
            includeBatteries: [false],
            signature: [false],
            cod: [false],
            oversizedPackage: [false],
        });
        this.packages.push(packagreForm);
    }

    onPackageTypeChage(index) {
        const pType = this.packages.at(index).get("packageType").value?.data;
        if (!pType) {
            this.packages.at(index).get("length").setValue("");
            this.packages.at(index).get("width").setValue("");
            this.packages.at(index).get("height").setValue("");
            this.packages.at(index).get("weight").setValue("");
        } else {
            this.packages.at(index).get("length").setValue(pType.length);
            this.packages.at(index).get("width").setValue(pType.width);
            this.packages.at(index).get("height").setValue(pType.height);
            this.packages.at(index).get("weight").setValue(pType.weight);
        }
    }

    getFormGroupAt(index) {
        return this.packages.at(index) as FormGroup;
    }

    removePackage(index: number) {
        this.packages.removeAt(index);
    }

    /** Shipment address Sales Order and Invoice */
    
    prepareShipFromAddress(obj, verify) {
        const shippingFromAddressObj = {
            address: {
                street1: obj?.warehouse?.address?.streetAddress1,
                street2: obj?.warehouse?.address?.streetAddress2,
                city: obj?.warehouse?.address?.city?.name,
                state: obj?.warehouse?.address?.state?.name,
                zip: obj?.warehouse?.address?.zipCode,
                country: obj?.warehouse?.address?.country?.name,
                name: obj?.warehouse?.name,
                phone: obj?.warehouse?.phoneNo,
                email: obj?.warehouse?.emailId,
                residential: false,
            },
            verify: verify,
        };
        return shippingFromAddressObj;
    }
    prepareShipToAddress(obj, verify) {
        const shippingToAddressObj = {
            address: {
                street1: obj?.address?.streetAddress1,
                street2: obj?.address?.streetAddress2,
                city: obj?.address?.city?.name,
                state: obj?.address?.state?.name,
                zip: obj?.address?.zipCode,
                country: obj?.address?.country?.name,
                name: this.prepareContactInfo(),
                // company: this.detailsObj?.account?.businessName || "",
                company: obj?.address?.addressName && obj?.address?.addressName?.length > 0 ? obj?.address?.addressName : this.detailsObj?.account?.businessName,
                phone: this.detailsObj?.shipContact && this.detailsObj?.shipContact?.contactPhones && this.detailsObj?.shipContact?.contactPhones[0]?.phone && this.detailsObj?.shipContact?.contactPhones[0]?.phone?.number ? this.detailsObj?.shipContact?.contactPhones[0]?.phone?.number : obj?.address?.attnContact && obj?.address?.attnContact?.contactPhones && obj?.address?.attnContact?.contactPhones?.length ? obj?.address?.attnContact?.contactPhones[0]?.phone?.number : "", // if provided , must be a valid phone no
                email: obj?.address?.attnContact && obj?.address?.attnContact?.contactEmails && obj?.address?.attnContact?.contactEmails?.length ? obj?.address?.attnContact?.contactEmails[0]?.email?.emailAddress : "", // if provided , must be a valid email
                residential: false,
            },
            verify: verify,
        };
        return shippingToAddressObj;
    }
    prepareContactInfo() {
        let contactName = "";
        if (this.shippingAddressContact?.firstName && this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.firstName + " " + this.shippingAddressContact.lastName;
        } else if (this.shippingAddressContact?.firstName) {
            contactName = this.shippingAddressContact.firstName;
        } else if (this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.lastName;
        } else {
            contactName = this.detailsObj?.account?.businessName || "";
        }
        return contactName;
    }

    /** End Shipment address Sales Order and Invoice */

    /** Customer Return address */
    
    /** Customer Return ship from address */
    prepareCustomerReturnShipFromAddress(obj, verify) {
        const shippingFromAddressObj = {
            address: {
                street1: obj?.address?.streetAddress1,
                street2: obj?.address?.streetAddress2,
                city: obj?.address?.city?.name,
                state: obj?.address?.state?.name,
                zip: obj?.address?.zipCode,
                country: obj?.address?.country?.name,
                name: this.prepareContactInfo(),
                // company: this.detailsObj?.account?.businessName || "",
                company: obj?.address?.addressName && obj?.address?.addressName?.length > 0 ? obj?.address?.addressName : this.detailsObj?.account?.businessName,
                phone: this.detailsObj?.shipContact && this.detailsObj?.shipContact?.contactPhones && this.detailsObj?.shipContact?.contactPhones[0]?.phone && this.detailsObj?.shipContact?.contactPhones[0]?.phone?.number ? this.detailsObj?.shipContact?.contactPhones[0]?.phone?.number : obj?.address?.attnContact && obj?.address?.attnContact?.contactPhones && obj?.address?.attnContact?.contactPhones?.length ? obj?.address?.attnContact?.contactPhones[0]?.phone?.number : "", // if provided , must be a valid phone no
                email: obj?.address?.attnContact && obj?.address?.attnContact?.contactEmails && obj?.address?.attnContact?.contactEmails?.length ? obj?.address?.attnContact?.contactEmails[0]?.email?.emailAddress : "", // if provided , must be a valid email
                residential: false,
            },
            verify: verify,
        };
        return shippingFromAddressObj;
    }
    /** Customer Return ship to address */
    prepareCustomerReturnShipToAddress(obj, verify) {
        const shippingFromAddressObj = {
            address: {
                street1: obj?.warehouse?.address?.streetAddress1,
                street2: obj?.warehouse?.address?.streetAddress2,
                city: obj?.warehouse?.address?.city?.name,
                state: obj?.warehouse?.address?.state?.name,
                zip: obj?.warehouse?.address?.zipCode,
                country: obj?.warehouse?.address?.country?.name,
                name: obj?.warehouse?.name,
                phone: obj?.warehouse?.phoneNo,
                email: obj?.warehouse?.emailId,
                residential: false,
            },
            verify: verify,
        };
        return shippingFromAddressObj;
    }

    /** End Customer Return address */


    /** Shipment Rates */

    getShippingCost() {
        if (this.form.value && this.form.value.packages && this.form.value.packages.length) {
            if (this.form.value.packages.length > 1 || Number(this.form.value.packages[0].totalPackage.name) > 1) {
                this.isSinglePackage = false;
                this.getMultiplePackageShippingCost();
            } else {
                this.isSinglePackage = true;
                this.getSinglePackageShippingCost();
            }
        }
    }
    getMultiplePackageShippingCost() {
        const shippingFromAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj, true) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, true);
        const shippingToAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, true) : this.prepareCustomerReturnShipToAddress(this.detailsObj, true);
        const shipments = [];
        this.form.value.packages.forEach((pck:any) => {
            for (let i = 0; i < Number(pck.totalPackage.name); i++) {
                const obj = {
                    parcel: {
                        length: pck?.length,
                        width: pck.width,
                        height: pck.height,
                        weight: pck.weight,
                    },
                    options: {
                        invoice_number: pck.reference1,
                        print_custom_1: pck.reference1,
                        print_custom_2: pck.reference2,
                        // delivery_confirmation: pck.signature
                        //     ? "SIGNATURE"
                        //     : "NO_SIGNATURE",
                        label_format: "PDF",
                    },
                };
                if (pck.includeBatteries) {
                    obj.options["hazmat"] = "LITHIUM";
                }
                if (pck.cod) {
                    obj.options["cod_amount"] = pck.codAmount;
                    obj.options["cod_method"] = pck.codMethod.name;
                } else {
                    obj.options["delivery_confirmation"] = pck.signature ? "SIGNATURE" : "NO_SIGNATURE";
                }
                shipments.push(obj);
            }
        });
        let fromAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let returnAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let toAddressRes = this.salesOrderService.saveShippingFromAddress(shippingToAddressObj);
        forkJoin([fromAddressRes, toAddressRes, returnAddressRes]).subscribe((response) => {
            const orderObj = {
                order: {
                    to_address: {
                        id: response[1].id,
                    },
                    from_address: {
                        id: response[0].id,
                    },
                    return_address: {
                        id: response[2].id,
                    },
                    shipments: shipments,
                },
            };
            let orderReq = this.salesOrderService.createOrder(orderObj);
            orderReq.subscribe((res) => {
                this.order = res;
                this.shipmentRates = res.rates;
                if (!res.rates || !res.rates.length) {
                    this.ratesText = "No rates found.";
                }
            });
        });
    } 
    getSinglePackageShippingCost() {
        this.shipmentRates = [];
        this.shipment = null;
        const shippingFromAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj, true) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, true);
        const shippingToAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, true) : this.prepareCustomerReturnShipToAddress(this.detailsObj, true);
        const formValue = this.form.value.packages[0];
        const shippingParcelObj = {
            parcel: {
                length: formValue.length,
                width: formValue.width,
                height: formValue.height,
                weight: this.utilityService.getOunceValue(formValue.weight, formValue.mass.code),
            },
        };

        let fromAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let returnAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let toAddressRes = this.salesOrderService.saveShippingFromAddress(shippingToAddressObj);
        let parcelRes = this.salesOrderService.saveShippingParcel(shippingParcelObj);
        forkJoin([fromAddressRes, toAddressRes, parcelRes, returnAddressRes]).subscribe((response) => {
            const shipmentObj = {
                shipment: {
                    to_address: {
                        id: response[1].id,
                    },
                    from_address: {
                        id: response[0].id,
                    },
                    return_address: {
                        id: response[3].id,
                    },
                    parcel: {
                        id: response[2].id,
                    },
                    insurance: formValue.packageValue ? formValue.packageValue : 0,
                    options: {
                        invoice_number: formValue.reference1,
                        print_custom_1: formValue.reference1,
                        print_custom_2: formValue.reference2,
                        label_format: "PDF",
                    },
                },
            };
            if (formValue.includeBatteries) {
                shipmentObj.shipment.options["hazmat"] = "LITHIUM";
            }
            if (formValue.cod) {
                shipmentObj.shipment.options["cod_amount"] = formValue.codAmount;
                shipmentObj.shipment.options["cod_method"] = formValue.codMethod.name;
                // shipmentObj.shipment.options["cod_method"] = "CASH";
            } else {
                shipmentObj.shipment.options["delivery_confirmation"] = formValue.signature ? "SIGNATURE" : "NO_SIGNATURE";
            }

            let shipment = this.salesOrderService.saveShipment(shipmentObj);
            shipment.subscribe((res) => {
                this.shipment = res;
                this.shipmentRates = res.rates;
                if (!res.rates || !res.rates.length) {
                    this.ratesText = "No rates found.";
                }

                // if(formValue.packageValue){
                //     const obj = {
                //         amount : formValue.packageValue
                //     }
                //     this.salesOrderService.getShipmentInsurance(res.id, obj).subscribe(res => {
                //         console.log('Response -->>', res);
                //     })
                // }
            });
        });
    }

    /** End Shipment rates */

    /** Generate Shipment Label */

    createLabel() {
        if (this.isSinglePackage) {
            this.createLabelForSinglePackage();
        } else {
            this.createLabelForMultiplePackage();
        }
    }
    createLabelForSinglePackage() {
        this.createLabelSubmitted = true;
        this.shipment = null;
        const shippingFromAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipFromAddress(this.detailsObj, true) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, true);
        const shippingToAddressObj = this.channel != this.soChannel.CUSTOMER_RETURNS ? this.prepareShipToAddress(this.shippingAddress, true) : this.prepareCustomerReturnShipToAddress(this.detailsObj, true);
        const formValue = this.form.value.packages[0];
        const shippingParcelObj = {
            parcel: {
                length: formValue.length,
                width: formValue.width,
                height: formValue.height,
                weight: this.utilityService.getOunceValue(formValue.weight, formValue.mass.code),
            },
        };

        let fromAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let returnAddressRes = this.salesOrderService.saveShippingFromAddress(shippingFromAddressObj);
        let toAddressRes = this.salesOrderService.saveShippingFromAddress(shippingToAddressObj);
        let parcelRes = this.salesOrderService.saveShippingParcel(shippingParcelObj);
        forkJoin([fromAddressRes, toAddressRes, parcelRes, returnAddressRes]).subscribe((response) => {
            const shipmentObj = {
                shipment: {
                    to_address: {
                        id: response[1].id,
                    },
                    from_address: {
                        id: response[0].id,
                    },
                    return_address: {
                        id: response[3].id,
                    },
                    parcel: {
                        id: response[2].id,
                    },
                    service: this.selectedService.service,
                    carrier_accounts: [this.selectedService.carrier_account_id],
                    insurance: formValue.packageValue ? formValue.packageValue : 0,
                    options: {
                        invoice_number: formValue.reference1,
                        print_custom_1: formValue.reference1,
                        print_custom_2: formValue.reference2,
                        label_format: "PDF",
                    },
                },
            };
            if (formValue.includeBatteries) {
                shipmentObj.shipment.options["hazmat"] = "LITHIUM";
            }
            if (formValue.cod) {
                shipmentObj.shipment.options["cod_amount"] = this.codAmount;
                shipmentObj.shipment.options["cod_method"] = formValue.codMethod.name;
            } else {
                shipmentObj.shipment.options["delivery_confirmation"] = formValue.signature ? "SIGNATURE" : "NO_SIGNATURE";
            }

            let shipment = this.salesOrderService.saveShipment(shipmentObj);
            shipment.subscribe(
                (res) => {
                    // this.appMainService.isHideSpinner("createLabel");
                    const data = {
                        type: "SINGLE_PACKAGE",
                        success: true,
                        label: res,
                        formValue: formValue,
                        selectedCarrier: this.selectedCarrier,
                        shippingCost: this.shippingCost,
                        isFreeShipping: this.isFreeShipping,
                        codCharge: formValue.cod ? formValue.codAmount : 0,

                        length: Number(formValue.length),
                        width: Number(formValue.width),
                        height: Number(formValue.height),
                        weight: Number(formValue.weight),
                        zipCode: this.shippingAddress?.address?.zipCode ?? "",
                        addressTypeId: this.shippingAddress?.address?.addressTypeId ?? "",
                        addressClassId: this.shippingAddress?.address?.addressClassId ?? "",
                        uomId: 0,
                        uomName: formValue?.mass?.name ?? "",
                        serviceName: this.selectedService?.carrier + " " + this.selectedService?.service,
                        serviceMethodTypeId: 0,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Label created Successfully...",
                    });
                    this.createLabelSubmitted = false;
                    this.onLabelCreate.emit(data);
                },
                (e) => {
                    // this.appMainService.isHideSpinner("createLabel");
                    this.createLabelSubmitted = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: e?.error?.Message,
                    });
                },
            );
        });
    }
    createLabelForMultiplePackage() {
        this.createLabelSubmitted = true;
        const formValue = this.form.value.packages[0];
        const orderId = this.order?.id;
        const obj = {
            carrier: this.selectedService.carrier,
            service: this.selectedService.service,
        };
        if (formValue.packageValue && Number(formValue.packageValue) > 100) {
            obj["insurance"] = formValue.packageValue;
        }
        this.appMainService.isShowSpinner("createLabel");
        this.salesOrderService.createLabelForMultiplePackage(orderId, obj).subscribe(
            (res) => {
                this.appMainService.isHideSpinner("createLabel");
                const data = {
                    type: "MULTI_PACKAGE",
                    success: true,
                    label: res,
                    selectedCarrier: this.selectedCarrier,
                    shippingCost: this.shippingCost,
                    isFreeShipping: this.isFreeShipping,
                    codCharge: formValue.cod ? formValue.codAmount : 0,
                    length: Number(formValue.length),
                    width: Number(formValue.width),
                    height: Number(formValue.height),
                    weight: Number(formValue.weight),
                    zipCode: this.shippingAddress?.address?.zipCode ?? "",
                    addressTypeId: this.shippingAddress?.address?.addressTypeId ?? "",
                    addressClassId: this.shippingAddress?.address?.addressClassId ?? "",
                    uomId: 0,
                    uomName: formValue?.mass?.name ?? "",
                    serviceName: this.selectedService?.carrier + " " + this.selectedService?.service,
                    serviceMethodTypeId: 0,
                };
                this.createLabelSubmitted = false;
                this.onLabelCreate.emit(data);
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }

    /** End Generate Label */


    onDialogClose() {
        this.onClose.emit();
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    showCodField() {
        this.isVisibleCodField = true;
    }

    hideCodField() {
        this.isVisibleCodField = false;
    }

    changeCODAmount() {
        if (this.isFreeShipping) {
            const formValue = this.form.value.packages[0];
            if (formValue.cod && formValue.codAmount) {
                this.codAmount -= Number(formValue.codAmount) + Number(this.shippingCost);
            }
        } else {
            this.codAmount = 0;
            const formValue = this.form.value.packages[0];
            if (formValue.cod && formValue.codAmount) {
                this.codAmount += Number(formValue.codAmount);
            }
            if (formValue.cod) {
                this.codAmount += Number(this.shippingCost) + Number(this.detailsObj.netAmount);
            }
        }
    }

    calculateCODAmount() {
        /**
         * Total COD amount is addition of ordertotal, service cost & cod charge
         */
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue.cod) {
            this.codAmount += Number(this.selectedService.rate) + Number(this.detailsObj.netAmount);
        }
    }

    showShippingCostField() {
        this.isVisibleShipCostField = true;
    }

    hideShippingCostField() {
        this.isVisibleShipCostField = false;
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue.cod) {
            this.codAmount += Number(this.shippingCost) + Number(this.detailsObj.netAmount);
        }
    }
}
